import { render, staticRenderFns } from "./shebao_bujiaofei.vue?vue&type=template&id=3821b8de&scoped=true"
import script from "./shebao_bujiaofei.vue?vue&type=script&lang=js"
export * from "./shebao_bujiaofei.vue?vue&type=script&lang=js"
import style0 from "./shebao_bujiaofei.vue?vue&type=style&index=0&id=3821b8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821b8de",
  null
  
)

export default component.exports